import { createIcon } from '../utils';

export const NonBillableIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13.7493 13.3337L17.916 17.5003M17.916 13.3337L13.7493 17.5003M18.3327 8.33366H1.66602M18.3327 10.0003V6.83366C18.3327 5.90024 18.3327 5.43353 18.151 5.07701C17.9912 4.76341 17.7363 4.50844 17.4227 4.34865C17.0661 4.16699 16.5994 4.16699 15.666 4.16699H4.33268C3.39926 4.16699 2.93255 4.16699 2.57603 4.34865C2.26243 4.50844 2.00746 4.7634 1.84767 5.07701C1.66602 5.43353 1.66602 5.90024 1.66602 6.83366V13.167C1.66602 14.1004 1.66602 14.5671 1.84767 14.9236C2.00746 15.2372 2.26243 15.4922 2.57603 15.652C2.93255 15.8337 3.39926 15.8337 4.33268 15.8337H9.99935"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'NonBillableIcon', defaultSize: 20 },
);
